module.exports = __webpack_public_path__ + "img/testimonial_mobil.08d89013.svg";